import { FC } from 'react';
import { Button, ButtonProps } from 'antd';

const DefaultButton: FC<ButtonProps> = ({ title, ...props }) => {
  return <Button {...props}>{title}</Button>;
};

export default DefaultButton;
